var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("Multiselect", {
    staticClass: "invitees-search",
    class: { showContent: _vm.inputGiven, "icon-loading": _vm.isLoading },
    attrs: {
      options: _vm.matches,
      searchable: true,
      "internal-search": false,
      "max-height": 600,
      "show-no-results": true,
      "show-no-options": false,
      placeholder: _vm.placeholder,
      "open-direction": "bottom",
      "track-by": "email",
      label: "dropdownName"
    },
    on: { "search-change": _vm.findAttendees, select: _vm.addAttendee },
    scopedSlots: _vm._u([
      {
        key: "singleLabel",
        fn: function(props) {
          return [
            _c(
              "div",
              { staticClass: "invitees-search-list-item" },
              [
                props.option.isUser
                  ? _c("Avatar", {
                      attrs: {
                        user: props.option.avatar,
                        "display-name": props.option.dropdownName
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                !props.option.isUser
                  ? _c("Avatar", {
                      attrs: {
                        url: props.option.avatar,
                        "display-name": props.option.dropdownName
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                props.option.hasMultipleEMails
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "invitees-search-list-item__label invitees-search-list-item__label--with-displayname"
                      },
                      [
                        _c("div", [
                          _vm._v(
                            "\n\t\t\t\t\t" +
                              _vm._s(props.option.commonName) +
                              "\n\t\t\t\t"
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _vm._v(
                            "\n\t\t\t\t\t" +
                              _vm._s(props.option.email) +
                              "\n\t\t\t\t"
                          )
                        ])
                      ]
                    )
                  : _c(
                      "div",
                      {
                        staticClass:
                          "invitees-search-list-item__label invitees-search-list-item__label--single-email"
                      },
                      [
                        _c("div", [
                          _vm._v(
                            "\n\t\t\t\t\t" +
                              _vm._s(props.option.dropdownName) +
                              "\n\t\t\t\t"
                          )
                        ])
                      ]
                    )
              ],
              1
            )
          ]
        }
      },
      {
        key: "option",
        fn: function(props) {
          return [
            _c(
              "div",
              { staticClass: "invitees-search-list-item" },
              [
                props.option.isUser
                  ? _c("Avatar", {
                      attrs: {
                        user: props.option.avatar,
                        "display-name": props.option.dropdownName
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                !props.option.isUser
                  ? _c("Avatar", {
                      attrs: {
                        url: props.option.avatar,
                        "display-name": props.option.dropdownName
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                props.option.hasMultipleEMails
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "invitees-search-list-item__label invitees-search-list-item__label--with-multiple-email"
                      },
                      [
                        _c("div", [
                          _vm._v(
                            "\n\t\t\t\t\t" +
                              _vm._s(props.option.commonName) +
                              "\n\t\t\t\t"
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _vm._v(
                            "\n\t\t\t\t\t" +
                              _vm._s(props.option.email) +
                              "\n\t\t\t\t"
                          )
                        ])
                      ]
                    )
                  : _c(
                      "div",
                      {
                        staticClass:
                          "invitees-search-list-item__label invitees-search-list-item__label--single-email"
                      },
                      [
                        _c("div", [
                          _vm._v(
                            "\n\t\t\t\t\t" +
                              _vm._s(props.option.dropdownName) +
                              "\n\t\t\t\t"
                          )
                        ])
                      ]
                    )
              ],
              1
            )
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }